import React, { useState } from 'react';
import styled from '@emotion/styled';
import { SearchIcon, XIcon } from './icons';
import Input from './Input';
import IconButton from './IconButton';

const SearchBarStyles = styled.div`
  cursor: pointer;
`;
const SearchOpenStyles = styled.div`
  background-color: #ecf0f1;
  position: absolute;
  /* transition: all 2s; */
  /* border-bottom: 2px solid #BCC2C7; */
  background-color: #ecf0f1;
  top: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  display: flex;
  padding: 0 24px;
  z-index: 500;
  border-radius: 5px;
  @media (min-width: 768px) {
    right: 180px;
  }
  @media (min-width: 1024px) {
    right: 220px;
  }
  @media (min-width: 1700px) {
    right: 375px;
  }
`;
const InputStyles = styled.input`
  width: 300px;
  padding-left:6px;
  background-color: #ecf0f1;
  border: none;
  /* height: 60px; */
  :focus {
    outline: none;
  }
  @media (min-width: 1024px) {
    width:400px;
  }
`;
interface Props {
  search: (searchText: string) => void;
  searchText: string;
  searchOpen: boolean;
  onSearchTextChange: (searchText: string) => void;
  setSearchOpen: (open: boolean) => void;
  closeSearch?: () => void;
  onEnterClick?: () => void;
}
const SearchBar = (props: Props) => {
  return (
    <>
      <SearchBarStyles onClick={() => props.setSearchOpen(true)}>
        <IconButton icon={<SearchIcon />} hoverColor='#ecf0f1' />
      </SearchBarStyles>
      {props.searchOpen && (
        <SearchOpenStyles>
          <SearchIcon />
          <InputStyles
            placeholder='Search for an order'
            value={props.searchText}
            onChange={(e: any) => {
              props.onSearchTextChange(e.target.value);
            }}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                props.onEnterClick()
              }
            }}
          />
          <XIcon
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: 16,
            }}
            onClick={props.closeSearch}
          />
        </SearchOpenStyles>
      )}
    </>
  );
};

export default SearchBar;
